import { render, staticRenderFns } from "./V2AboutCard.vue?vue&type=template&id=6653c5f0&scoped=true&"
import script from "./V2AboutCard.vue?vue&type=script&lang=js&"
export * from "./V2AboutCard.vue?vue&type=script&lang=js&"
import style0 from "./V2AboutCard.vue?vue&type=style&index=0&id=6653c5f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6653c5f0",
  null
  
)

export default component.exports